// This file was auto-generated by Fern from our API Definition.
/** How an upstream model deployment is reached. */
export const LlmDeploymentKind = {
    Direct: "direct",
    Custom: "custom",
    Azure: "azure",
    Bedrock: "bedrock",
    Sagemaker: "sagemaker",
    VertexAi: "vertex_ai",
    Mock: "mock",
};
